var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, OnInit, QueryList, } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { CropperSettings } from 'ngx-img-cropper';
import { isNullOrUndefined } from 'util';
import { config } from '../../../../../config/config';
import { CreateTourCommand } from '../../../../commands/hub/create.tour.command';
import { ConfirmModalComponent } from '../../../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData, } from '../../../../common/components/confirm.modal/confirm.modal.provider';
import { ImageCropperWithPreviewComponent } from '../../../../common/components/image.cropper/image.cropper.component';
import { routeConfigs } from '../../../../common/constants/route.config';
import { HubVisitorFeatureToggle } from '../../../../models/hub/hub.visitor.feature.toggle';
import { AlertifyService } from '../../../../services/alertify.service';
import { PDFSettingsStore, ToggleAndDataSourceStore, ToursStore } from '../../../../stores/hub.calendar.store';
import { PDFSettingCommand } from '../../export.pdf.modal/export.pdf.modal.provider';
import { InfoModalData, ShowInfoModalActions } from '../../show.info.modal/show.info.modal.provider';
import { EditTourTitleModalComponent } from '../edit.tour.title.modal/edit.tour.title.modal.component';
import { EditTourTitleModalActions, EditTourTitleModalData, } from '../edit.tour.title.modal/edit.tour.title.modal.provider';
import { ImageSelectorComponent } from '../../../../common/components/image.selector/image.selector.component';
import { BaseComponent } from '../../../../common/components/base.component';
import { PageSpinnerComponent } from '../../../../common/components/page.spinner/page.spinner.component';
import { RowActionButtonsComponent } from '../../../../common/components/row.action.buttons/row.action.buttons.component';
import { GoogleMapsService } from '../../../../common/services/google.maps.service';
import { ModalService } from '../../../../common/services/modal.service';
import { CustomizationApiService } from '../../../../services/customization.api.service';
import { HubApiService } from '../../../../services/hub.api.service';
import { ImageService } from '../../../../services/image.service';
import { HubComponent } from '../../hub.component';
import { AttractionListComponent } from '../attractions/attraction.list.component';
import { DirectionPlanComponent } from '../direction.plan/direction.plan.component';
import { ShowInfoModalComponent } from 'components/hub/show.info.modal/show.info.modal.component';
import { localStorageKeys } from '../../../../common/constants/local.storage.keys';
import * as jwt_decode from 'jwt-decode';
import { isEmptyArray } from '../../../../common/extensions';
import { AccountApiService } from '../../../../services/account.api.service';
import { takeUntil } from 'rxjs/operators';
var TourComponent = /** @class */ (function (_super) {
    __extends(TourComponent, _super);
    function TourComponent(hubApiService, formBuilder, activatedRoute, accountService, customizationService, parent, alertify, imageService, pdfSettingsStore, toursStore, toggleAndDataSourceStore, googleMapService, modalService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.hubApiService = hubApiService;
        _this.formBuilder = formBuilder;
        _this.activatedRoute = activatedRoute;
        _this.accountService = accountService;
        _this.customizationService = customizationService;
        _this.parent = parent;
        _this.alertify = alertify;
        _this.imageService = imageService;
        _this.pdfSettingsStore = pdfSettingsStore;
        _this.toursStore = toursStore;
        _this.toggleAndDataSourceStore = toggleAndDataSourceStore;
        _this.googleMapService = googleMapService;
        _this.modalService = modalService;
        _this.hubName = '';
        _this.isShowMobileEdit = false;
        _this.command = new CreateTourCommand();
        _this.updateCommand = new CreateTourCommand();
        _this.isLoadingTourList = false;
        _this.isLoadingDetailsStyle = false;
        _this.isLoadingV3Settings = false;
        _this.aiSettings = null;
        _this.success = false;
        _this.isPlanStarted = false;
        _this.isLoading = false;
        _this.showExceedTip = false;
        _this.toggles = new HubVisitorFeatureToggle();
        _this.imageTemp = null;
        _this.tpHomeImage = {
            isDefault: true,
            url: '',
        };
        _this.tourSidebarImage = {
            isDefault: true,
            url: '',
        };
        _this.detailsPreview = config.tripPlanner.detailsPreview;
        _this.sideFloatView = config.tripPlanner.sideFloatView;
        _this.popupView = config.tripPlanner.popupView;
        _this.maxCroppedWidth = 800;
        _this.tpSettings = {
            defaultAISuggestedItineraries: '',
            mobileLandingPage: {
                bannerImage: '',
                eventImage: '',
                placeImage: '',
                itineraryImage: '',
                tripImage: '',
                bannerText1: '',
                bannerText2: '',
            },
            desktopPage: {
                listColumns: 4,
                listMargin: 0,
            },
        };
        _this.bannerImgData = null;
        _this.eventImgData = null;
        _this.placeImgData = null;
        _this.itineraryImgData = null;
        _this.tripImgData = null;
        _this.defaultBannerImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-banner.jpg';
        _this.defaultEventImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-event.jpg';
        _this.defaultPlaceImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-place.jpg';
        _this.defaultItineraryImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-itinerary.jpg';
        _this.defaultTripImage = 'https://iti-images.s3.us-east-1.amazonaws.com/imgs/mobile-trip.jpg';
        _this.tpHomeImageData = {};
        _this.tourSidebarImageData = {};
        _this.PDFSettings = {
            pdf: {
                headerImage: {
                    event: { isDefault: true, url: null },
                    place: { isDefault: true, url: null },
                    tour: { isDefault: true, url: null },
                    trip: { isDefault: true, url: null },
                },
            },
            eventCalendarURL: null,
            placeCalendarURL: null,
            moreToursURL: null,
        };
        _this.tempPDFSettings = {
            pdf: {
                headerImage: {
                    event: { isDefault: true, url: null },
                    place: { isDefault: true, url: null },
                    tour: { isDefault: true, url: null },
                    trip: { isDefault: true, url: null },
                },
            },
            eventCalendarURL: null,
            placeCalendarURL: null,
            moreToursURL: null,
        };
        _this.PDFSettingImageCorperData = {
            event: {},
            place: {},
            tour: {},
            trip: {},
        };
        return _this;
    }
    TourComponent.prototype.ngOnDestroy = function () {
        if (this.previewInterval) {
            clearInterval(this.previewInterval);
        }
    };
    TourComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.parent.location = 'Trip Planner';
        //this.detailsPreview = this.imageService.imageSourceUrl(config.tripPlanner.detailsPreview);
        //this.sideFloatView = this.imageService.imageSourceUrl(config.tripPlanner.sideFloatView);
        //this.popupView = this.imageService.imageSourceUrl(config.tripPlanner.popupView);
        this.createTourForm = this.formBuilder.group({
            title: [null, [Validators.required]],
            description: [null, []],
        });
        this.editTourForm = this.formBuilder.group({
            title: [null, [Validators.required]],
            description: [null, []],
            v3DefaultAISuggestedItinerary1: [null, []],
            v3DefaultAISuggestedItinerary2: [null, []],
            v3DefaultAISuggestedItinerary3: [null, []],
            mobileBannerText1: [null, []],
            mobileBannerText2: [null, []],
            mobileBannerImage: [null, []],
            mobileEventImage: [null, []],
            mobilePlaceImage: [null, []],
            mobileItineraryImage: [null, []],
            mobileTripImage: [null, []],
        });
        this.clearImgDataIfInputImageUrl();
        this.getTours();
        this.cropperSettingsForPDF = new CropperSettings();
        this.cropperSettingsForTourSidebar = new CropperSettings();
        this.toggleAndDataSourceStore.toggleAndDataSourceCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (toggleCommand) {
            if (toggleCommand && toggleCommand.toggle) {
                _this.toggles = toggleCommand.toggle;
            }
        });
        setTimeout(function () {
            var rect = _this.tab._elementRef.nativeElement.getBoundingClientRect(); //1228 / 3;
            var width = (rect.width - 18 * 6 - 24) / 3;
            width = width <= 0 ? window.innerWidth * 0.379 : width;
            var height = (width * 60) / 210;
            _this.cropperSettingsForPDF = _this.imageService.createImageCropperSetting(width, height, true);
            _this.cropperSettingsForTourSidebar = _this.imageService.createImageCropperSetting(400, 600, true);
            // this.cropperSettingsForTourSidebar = this.imageService.createImageCropperSetting(543, 600, true, 600);
            _this.customizationService.getTPHomeAndTourSidebarImage(_this.hubName).subscribe(function (images) {
                _this.tpHomeImage.isDefault =
                    isNullOrUndefined(images.tpHomeImage) ||
                        isNullOrUndefined(images.tpHomeImage.isDefault) ||
                        images.tpHomeImage.isDefault;
                _this.tpHomeImage.url = isNullOrUndefined(images.tpHomeImage) ? null : images.tpHomeImage.url;
                _this.tourSidebarImage.isDefault =
                    isNullOrUndefined(images.tourSidebarImage) ||
                        isNullOrUndefined(images.tourSidebarImage.isDefault) ||
                        images.tourSidebarImage.isDefault;
                _this.tourSidebarImage.url = isNullOrUndefined(images.tourSidebarImage) ? null : images.tourSidebarImage.url;
                if (_this.tpHomeImage.url) {
                    _this.tpHomeImageData.image = _this.tpHomeImage.url;
                    _this.logoImageSet('tpHomeImage');
                }
                if (_this.tourSidebarImage.url) {
                    _this.tourSidebarImageData.image = _this.tourSidebarImage.url;
                    // this.logoImageSet('tpHomeImage');
                }
                setTimeout(function () {
                    _this.tpHomeImgCropper && _this.tpHomeImgCropper.setImageData(_this.cropperSettingsForPDF);
                    _this.tourSidebarImgCropper && _this.tourSidebarImgCropper.setImageData(_this.cropperSettingsForTourSidebar);
                });
            });
            _this.customizationService.getPDFSettings(_this.hubName).subscribe(function (settings) {
                _this.PDFSettings.pdf.headerImage.event.isDefault =
                    isNullOrUndefined(settings) ||
                        isNullOrUndefined(settings.pdf.headerImage.event.isDefault) ||
                        settings.pdf.headerImage.event.isDefault;
                _this.PDFSettings.pdf.headerImage.event.url = _this.PDFSettings.pdf.headerImage.event.isDefault
                    ? null
                    : settings.pdf.headerImage.event.url;
                _this.PDFSettings.pdf.headerImage.place.isDefault =
                    isNullOrUndefined(settings) ||
                        isNullOrUndefined(settings.pdf.headerImage.place.isDefault) ||
                        settings.pdf.headerImage.place.isDefault;
                _this.PDFSettings.pdf.headerImage.place.url = _this.PDFSettings.pdf.headerImage.place.isDefault
                    ? null
                    : settings.pdf.headerImage.place.url;
                _this.PDFSettings.pdf.headerImage.tour.isDefault =
                    isNullOrUndefined(settings) ||
                        isNullOrUndefined(settings.pdf.headerImage.tour.isDefault) ||
                        settings.pdf.headerImage.tour.isDefault;
                _this.PDFSettings.pdf.headerImage.tour.url = _this.PDFSettings.pdf.headerImage.tour.isDefault
                    ? null
                    : settings.pdf.headerImage.tour.url;
                if (_this.PDFSettings.pdf.headerImage.tour.url) {
                    _this.PDFSettingImageCorperData.tour.image = _this.PDFSettings.pdf.headerImage.tour.url;
                }
                _this.PDFSettings.pdf.headerImage.trip.isDefault =
                    isNullOrUndefined(settings) ||
                        isNullOrUndefined(settings.pdf.headerImage.trip.isDefault) ||
                        settings.pdf.headerImage.trip.isDefault;
                _this.PDFSettings.pdf.headerImage.trip.url = _this.PDFSettings.pdf.headerImage.trip.isDefault
                    ? null
                    : settings.pdf.headerImage.trip.url;
                if (_this.PDFSettings.pdf.headerImage.trip.url) {
                    _this.PDFSettingImageCorperData.trip.image = _this.PDFSettings.pdf.headerImage.trip.url;
                }
                setTimeout(function () {
                    _this.tourImgCropper && _this.tourImgCropper.setImageData(_this.cropperSettingsForPDF);
                    _this.tripImgCropper && _this.tripImgCropper.setImageData(_this.cropperSettingsForPDF);
                });
            });
            _this.getDetailsStyle();
        }, 2000);
    };
    TourComponent.prototype.clearImgDataIfInputImageUrl = function () {
        var _this = this;
        var _loop_1 = function (element) {
            this_1.editTourForm
                .get("mobile" + element.upperFirstLetter() + "Image")
                .valueChanges.pipe(takeUntil(this_1.isDestroyed))
                .subscribe(function (changes) {
                if (changes) {
                    _this[element + 'ImgData'] = null;
                }
            });
        };
        var this_1 = this;
        for (var _i = 0, _a = ['banner', 'event', 'place', 'itinerary', 'trip']; _i < _a.length; _i++) {
            var element = _a[_i];
            _loop_1(element);
        }
    };
    TourComponent.prototype.getAISettings = function () {
        var _this = this;
        this.isLoadingTourList = true;
        this.hubApiService.getAISettings(this.hubName).subscribe(function (data) {
            if (!data) {
                _this.alertify.error("Something went wrong when getting AI settings");
                return;
            }
            _this.aiSettings = data;
            _this.customizationService.getTripPlannerSettings(_this.hubName).subscribe(function (settings) {
                if (!settings)
                    return;
                _this.tpSettings = settings;
                if (isEmptyArray(settings.defaultAISuggestedItineraries)) {
                    _this.editTourForm
                        .get('v3DefaultAISuggestedItinerary1')
                        .setValue("Suggest a one-day itinerary in " + (_this.aiSettings.travelBuddy.cityName || '(Your city name)') + ".");
                    _this.editTourForm
                        .get('v3DefaultAISuggestedItinerary2')
                        .setValue("Suggest a foodie itinerary in " + (_this.aiSettings.travelBuddy.cityName || '(Your city name)') + ".");
                    _this.editTourForm
                        .get('v3DefaultAISuggestedItinerary3')
                        .setValue("Suggest a kid-friendly itinerary in " + (_this.aiSettings.travelBuddy.cityName || '(Your city name)') + ".");
                }
                else {
                    settings.defaultAISuggestedItineraries.forEach(function (aiItinerary, index) {
                        _this.editTourForm.get("v3DefaultAISuggestedItinerary" + (index + 1)).setValue(aiItinerary.title);
                    });
                }
            });
        });
    };
    TourComponent.prototype.getTours = function () {
        var _this = this;
        this.isLoadingTourList = true;
        this.editMode = [];
        this.hubApiService.getTours(this.hubName).subscribe(function (data) {
            data.forEach(function (x) {
                _this.editMode.push(false);
            });
            _this.tours = data;
            _this.isLoadingTourList = false;
            _this.toursStore.toursCommand.next(_this.tours);
        });
    };
    TourComponent.prototype.deleteTour = function (index, $event) {
        var _this = this;
        if ($event) {
            $event.stopPropagation();
        }
        var actions = {
            confirm: function (event) {
                _this.cancelAllEdit();
                _this.hubApiService
                    .deleteTour(_this.hubName, _this.tours[index]._id)
                    .finally(event.complete)
                    .subscribe(function () {
                    _this.hubApiService.getTours(_this.hubName).subscribe(function (tours) {
                        _this.tours = tours;
                        _this.toursStore.toursCommand.next(_this.tours);
                    });
                });
            },
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: "Are you sure you want to delete the tour \"" + this.tours[index].title + "\"?",
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true,
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data },
            ],
        });
    };
    TourComponent.prototype.publishOrDePublishTour = function (tour) {
        var _this = this;
        if (tour.isActive) {
            this.hubApiService.publishTour(this.hubName, tour._id).subscribe(function () {
                _this.tours[_this.editingIndex].isActive = tour.isActive;
                _this.alertify.success('This itinerary is active');
                if (!window.location.href.includes('localhost')) {
                    var authToken = localStorage.getItem(localStorageKeys.authToken);
                    var tokenInfo = jwt_decode(authToken);
                    try {
                        var trackName = 'ActiveItinerary - ' + tour.title;
                        window['pendo'].track(trackName, {
                            accountId: tokenInfo.userName,
                            timestamp: Date.now(),
                            hubName: _this.hubName,
                        });
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
            });
        }
        else {
            this.hubApiService.dePublishTour(this.hubName, tour._id).subscribe(function () {
                _this.tours[_this.editingIndex].isActive = tour.isActive;
                _this.alertify.success('This itinerary is inactive');
                if (!window.location.href.includes('localhost')) {
                    var authToken = localStorage.getItem(localStorageKeys.authToken);
                    var tokenInfo = jwt_decode(authToken);
                    try {
                        var trackName = 'InactiveItinerary - ' + tour.title;
                        window['pendo'].track(trackName, {
                            accountId: tokenInfo.userName,
                            timestamp: Date.now(),
                            hubName: _this.hubName,
                        });
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
            });
        }
    };
    TourComponent.prototype.updateImage = function (image) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var imageTemp, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!image) return [3 /*break*/, 4];
                        this.imageSelector.showSpinner();
                        if (!this.updateCommand.image) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(this.updateCommand.image, config.compressImgWidth)];
                    case 1:
                        imageTemp = _a.sent();
                        return [4 /*yield*/, this.hubApiService.uploadBase64ImageToAWS(imageTemp)];
                    case 2:
                        res = _a.sent();
                        if (res.success) {
                            this.updateCommand.image = null;
                            this.updateCommand.imageLink = res.url;
                        }
                        _a.label = 3;
                    case 3:
                        this.hubApiService.updateTourImage(this.hubName, this.editingTour._id, this.updateCommand).subscribe(function (data) {
                            if (data && data.imageNotUploaded) {
                                _this.modalService.showErrorModal('Image upload failed!');
                                return;
                            }
                            _this.imageSelector.hideSpinner();
                            _this.alertify.successfully('Update image');
                            _this.imageSelector.command.image = null;
                        });
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TourComponent.prototype.onImageChange = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!file) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(file, config.compressImgWidth)];
                    case 1:
                        _a.imageTemp = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TourComponent.prototype.onMobileImageChange = function (file, type) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!file)
                            return [2 /*return*/];
                        _a = this;
                        _b = type + "ImgData";
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(file, config.compressImgWidth)];
                    case 1:
                        _a[_b] = _c.sent();
                        this.tpSettings.mobileLandingPage[type + "Image"] = '';
                        return [2 /*return*/];
                }
            });
        });
    };
    TourComponent.prototype.closeTip = function () {
        this.showExceedTip = false;
    };
    TourComponent.prototype.createTour = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.toggles.tour.limit.limited && this.tours && this.tours.length >= this.toggles.tour.limit.limitation) {
                            event.complete();
                            this.showExceedTip = true;
                            return [2 /*return*/];
                        }
                        this.showExceedTip = false;
                        this.command.order = this.tours.length;
                        if (!this.imageTemp) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.hubApiService.uploadBase64ImageToAWS(this.imageTemp)];
                    case 1:
                        res = _a.sent();
                        if (res.success) {
                            this.command.image = null;
                            this.command.imageLink = res.url;
                        }
                        _a.label = 2;
                    case 2:
                        this.hubApiService
                            .createTour(this.hubName, this.command)
                            .finally(event.complete)
                            .subscribe(function () {
                            _this.command = new CreateTourCommand();
                            _this.imageTemp = null;
                            _this.createTourForm.markAsPristine();
                            _this.selectedImageData = null;
                            _this.getTours();
                            _this.alertify.successfully('Create itinerary');
                            if (!window.location.href.includes('localhost')) {
                                var authToken = localStorage.getItem(localStorageKeys.authToken);
                                var tokenInfo = jwt_decode(authToken);
                                try {
                                    var trackName = 'CreateItinerary - ' + _this.command.title;
                                    window['pendo'].track(trackName, {
                                        accountId: tokenInfo.userName,
                                        timestamp: Date.now(),
                                        hubName: _this.hubName,
                                    });
                                }
                                catch (error) {
                                    console.error(error);
                                }
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TourComponent.prototype.edit = function (index, $event) {
        var _this = this;
        if ($event) {
            $event.stopPropagation();
        }
        if (this.isMobile) {
            this.showMobileEdit();
            this.openTourMobile(index);
            return;
        }
        if (index < this.editMode.length) {
            this.editingIndex = index;
            this.editMode.forEach(function (x, ind) {
                if (ind !== index) {
                    _this.editMode[ind] = false;
                }
            });
            setTimeout(function () {
                _this.openTour(index);
            });
        }
    };
    TourComponent.prototype.showLink = function (index, $event) {
        if ($event) {
            $event.stopPropagation();
        }
        if (index < 0 || index > this.tours.length - 1) {
            return;
        }
        var link = "" + config.serverDomain + this.hubName + "/" + routeConfigs.tripPlanner.tourShare.path.substr(0, routeConfigs.tripPlanner.tourShare.path.indexOf('/:'));
        link += '/' + this.tours[index]._id;
        this.modalService.show({
            component: ShowInfoModalComponent,
            providers: [
                { provide: ShowInfoModalActions, useValue: null },
                { provide: InfoModalData, useValue: new InfoModalData('Itinerary Link', null, [link]) },
            ],
            panelClass: 'width-modal-2',
        });
    };
    TourComponent.prototype.onItemDrop = function (e, toIndex) {
        var _this = this;
        if (!e || !e.dragData || isNullOrUndefined(e.dragData.order) || isNullOrUndefined(toIndex)) {
            return;
        }
        var tempOrder = e.dragData.order;
        e.dragData.order = this.tours[toIndex].order;
        this.tours[toIndex].order = tempOrder;
        this.tours.sort(function (a, b) { return a.order - b.order; });
        this.isLoading = true;
        this.hubApiService.updateTours(this.hubName, this.tours).subscribe(function (data) {
            _this.isLoading = false;
            _this.alertify.successfully('Change itinerary order');
        });
    };
    TourComponent.prototype.logoImageSet = function (type) {
        var _this = this;
        setTimeout(function () {
            var width = 0, height = 0;
            width = Math.min(_this.maxCroppedWidth, _this.cropperSettingsForPDF.croppedWidth);
            height = (width * _this.cropperSettingsForPDF.croppedHeight) / _this.cropperSettingsForPDF.croppedWidth;
            var target = null;
            switch (type) {
                case 'tour':
                    target = _this.pdfTourImage;
                    break;
                case 'trip':
                    target = _this.pdfTripImage;
                    break;
                case 'tpHomeImage':
                    target = _this.pdfTripImage;
                    break;
                default:
                    break;
            }
            if (target && target.nativeElement) {
                target.nativeElement.style.width = width + "px";
                target.nativeElement.style.height = height + "px";
            }
        });
    };
    TourComponent.prototype.setDetailsStyle = function () {
        var _this = this;
        this.customizationService.setTPDetailsStyle(this.hubName, this.detailsStyle).subscribe(function () {
            _this.alertify.successfully('Change details panel style');
        });
    };
    TourComponent.prototype.tabChanged = function ($event) {
        if (!window.location.href.includes('localhost')) {
            var authToken = localStorage.getItem(localStorageKeys.authToken);
            var tokenInfo = jwt_decode(authToken);
            try {
                var eventName = (this.type === 'tour' ? 'ContentManagement - ItineraryBuilder - ' : 'ContentManagement -  TripPlanner - ') +
                    $event.tab.textLabel;
                var trackName = 'click - ' + eventName + $event.tab.textLabel;
                window['pendo'].track(trackName, {
                    accountId: tokenInfo.userName,
                    timestamp: Date.now(),
                    hubName: this.hubName,
                });
            }
            catch (error) {
                console.error(error);
            }
        }
        if ($event.index === 3) {
            if (!this.aiSettings) {
                this.getAISettings();
            }
        }
    };
    TourComponent.prototype.openNewItineraryBuilder = function () {
        // const url = "https://devnext.imgoingcalendar.com/Savannah/itineraries/edit";
        var url = window.location.href.includes('localhost')
            ? "https://localhost:4201/" + this.hubName + "/itineraries/edit"
            : "" + config.serverDomainV3 + this.hubName + "/itineraries/edit";
        var windowName = 'PopupWindow';
        var windowFeatures = 'width=2500,height=1400,toolbar=no,location=no,directories=no,status=no,menubar=no,resizable=yes,scrollbars=yes';
        var popup = window.open(url, windowName, windowFeatures);
        if (popup) {
            /**
             * here we use a simple post message to avoid Itinerary V3 editor requires authentication
             * although this is not a very secure way, for systems like ImGoing, it can be understood as sacrificing a certain level of security in exchange for ease of use
             * send it multiple times to ensure the popup window is opened and can receive the message, can refacor here
             * */
            this.postMessageToItineraryBuilderV3(popup, 2000);
            this.postMessageToItineraryBuilderV3(popup, 4000);
            this.postMessageToItineraryBuilderV3(popup, 7000);
            if (!window.location.href.includes('localhost')) {
                var authToken = localStorage.getItem(localStorageKeys.authToken);
                if (authToken) {
                    var tokenInfo = jwt_decode(authToken);
                    try {
                        var trackName = 'ItineraryBuilder - V3 - OpenNewItineraryBuilder';
                        window['pendo'].track(trackName, {
                            accountId: tokenInfo.userName,
                            timestamp: Date.now(),
                            hubName: this.hubName,
                        });
                    }
                    catch (error) {
                        console.error(error);
                    }
                }
            }
        }
        else {
            alert('Popup blocked. Please check your browser settings.');
        }
    };
    TourComponent.prototype.postMessageToItineraryBuilderV3 = function (popup, delay) {
        setTimeout(function () {
            popup.postMessage({ type: 'origin', data: 'REDIRECT_FROM_DXP' }, '*');
        }, delay);
    };
    TourComponent.prototype.getDetailsStyle = function () {
        var _this = this;
        this.isLoadingDetailsStyle = true;
        this.customizationService.getTPDetailsStyle(this.hubName).subscribe(function (style) {
            _this.isLoadingDetailsStyle = false;
            _this.detailsStyle = style;
            _this.setPreviewInterval();
        });
    };
    TourComponent.prototype.setPreviewInterval = function () {
        var _this = this;
        this.previewInterval = setInterval(function () {
            if (_this.detailsStyle === 'float') {
                if (_this.sideFloat) {
                    _this.sideFloat.nativeElement.style.left = '435px';
                    _this.sideFloat.nativeElement.style.opacity = 1;
                    setTimeout(function () {
                        if (_this.sideFloat) {
                            _this.sideFloat.nativeElement.style.left = '333px';
                            _this.sideFloat.nativeElement.style.opacity = 0;
                        }
                    }, 2000);
                }
            }
            else if (_this.detailsStyle === 'popup') {
                if (_this.popup) {
                    _this.popup.nativeElement.style.top = '30px';
                    _this.popup.nativeElement.style.opacity = 1;
                    setTimeout(function () {
                        if (_this.popup) {
                            _this.popup.nativeElement.style.top = '60px';
                            _this.popup.nativeElement.style.opacity = 0;
                        }
                    }, 2000);
                }
            }
        }, 3000);
    };
    TourComponent.prototype.openTour = function (index) {
        var _this = this;
        this.actionButtons.toArray()[index].startLoading();
        this.hubApiService.getTourDetail(this.hubName, this.tours[index]._id).subscribe(function (data) {
            _this.actionButtons.toArray()[index].stopLoading();
            var items = [];
            data.attractions.forEach(function (item) {
                if (item.status !== 'not found') {
                    items.push(item);
                }
            });
            data.attractions = items;
            _this.editMode[index] = true;
            _this.editingTour = data;
            _this.editingTour.isEventImageProcessed = true;
            _this.editingImageData = _this.imageService.imageSourceUrl(_this.editingTour.image);
        });
    };
    TourComponent.prototype.openTourMobile = function (index) {
        var _this = this;
        this.mobileEditSpinner.show();
        this.hubApiService.getTourDetail(this.hubName, this.tours[index]._id).subscribe(function (data) {
            var items = [];
            data.attractions.forEach(function (item) {
                if (item.status !== 'not found') {
                    items.push(item);
                }
            });
            data.attractions = items;
            _this.editingTour = data;
            _this.editingImageData = _this.imageService.imageSourceUrl(_this.editingTour.image);
            _this.isShowMobileEdit = true;
            setTimeout(function () {
                _this.mobileEditSpinner.hide();
            }, 500);
        });
    };
    TourComponent.prototype.cancelEdit = function (index) {
        if (this.isMobile) {
            this.hideMobileEdit();
        }
        else {
            if (index < this.editMode.length) {
                this.editMode[index] = false;
            }
        }
    };
    TourComponent.prototype.cancelAllEdit = function () {
        for (var i = 0; i < this.editMode.length; i++) {
            this.editMode[i] = false;
        }
    };
    TourComponent.prototype.showEditTitlePopup = function () {
        var _this = this;
        var actions = {
            confirm: function (event, title, description) {
                _this.tours[_this.editingIndex].title = title;
                _this.tours[_this.editingIndex].description = description;
                _this.editingTour.title = title;
                _this.editingTour.description = description;
            },
        };
        var data = {
            isAsync: true,
            id: this.editingTour._id,
            title: this.editingTour.title,
            description: this.editingTour.description,
            hubName: this.hubName,
        };
        this.modalService.show({
            component: EditTourTitleModalComponent,
            providers: [
                { provide: EditTourTitleModalActions, useValue: actions },
                { provide: EditTourTitleModalData, useValue: data },
            ],
        });
    };
    TourComponent.prototype.startPlan = function () {
        this.isPlanStarted = true;
        this.attractionList.detailsPanel.closeDetails();
    };
    TourComponent.prototype.stopPlan = function () {
        this.isPlanStarted = false;
    };
    TourComponent.prototype.redrawDirectionMap = function (tour) {
        this.editingTour = tour;
        this.directionPlan.setTour(this.editingTour);
        this.directionPlan.drawFullRoute();
    };
    TourComponent.prototype.saveTPHomeImage = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var imageFile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        imageFile = this.imageService.getImageFileByBase64(this.tpHomeImageData.image);
                        return [4 /*yield*/, this.imageService.compressImageFile(imageFile, 780)];
                    case 1:
                        // let data = {isDefault: this.tpHomeImage.isDefault, url: this.tpHomeImageData.image};
                        //this.customizationService.setTPHomeImage(this.hubName, data)
                        imageFile = _a.sent();
                        this.customizationService
                            .setTPHomeImageFile(this.hubName, {
                            isDefault: this.tpHomeImage.isDefault,
                            image: imageFile,
                        })
                            .finally(event.complete)
                            .subscribe(function () {
                            _this.alertify.successfully('Update Trip Planner Home image');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TourComponent.prototype.saveTourSidebarImage = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = '';
                        if (!!this.tourSidebarImage.isDefault) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.hubApiService.uploadBase64ImageToAWS(this.tourSidebarImageData.image, 1200)];
                    case 1:
                        res = _a.sent();
                        if (res.success) {
                            url = res.url;
                        }
                        else {
                            this.alertify.error('Upload image failed, please try again.');
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        this.customizationService
                            .setTourSidebarImageFile(this.hubName, {
                            isDefault: this.tourSidebarImage.isDefault,
                            imageUrl: url,
                        })
                            .finally(event.complete)
                            .subscribe(function () {
                            _this.alertify.successfully('Update itinerary sidebar image');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TourComponent.prototype.savePDFTourHeaderImage = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var data, imageFile, imageBase64;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {
                            isDefault: this.PDFSettings.pdf.headerImage.tour.isDefault,
                            url: '',
                        };
                        if (!!this.PDFSettings.pdf.headerImage.tour.isDefault) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.imageService.compressImageFile(this.imageService.getImageFileByBase64(this.PDFSettingImageCorperData.tour.image), 780)];
                    case 1:
                        imageFile = _a.sent();
                        return [4 /*yield*/, this.imageService.getBase64ByImageFile(imageFile)];
                    case 2:
                        imageBase64 = _a.sent();
                        data = {
                            isDefault: this.PDFSettings.pdf.headerImage.tour.isDefault,
                            url: imageBase64,
                        };
                        _a.label = 3;
                    case 3:
                        this.customizationService
                            .setPDFTourHeaderImage(this.hubName, data)
                            .finally(event.complete)
                            .subscribe(function () {
                            _this.alertify.successfully('Update export PDF itinerary image');
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TourComponent.prototype.savePDFTripHeaderImage = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var imageFile, imageBase64, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.imageService.compressImageFile(this.imageService.getImageFileByBase64(this.PDFSettingImageCorperData.trip.image), 780)];
                    case 1:
                        imageFile = _a.sent();
                        return [4 /*yield*/, this.imageService.getBase64ByImageFile(imageFile)];
                    case 2:
                        imageBase64 = _a.sent();
                        data = {
                            isDefault: this.PDFSettings.pdf.headerImage.trip.isDefault,
                            url: imageBase64,
                        };
                        this.customizationService
                            .setPDFTripHeaderImage(this.hubName, data)
                            .finally(event.complete)
                            .subscribe(function () {
                            _this.alertify.successfully('Update export PDF user trip image');
                            //this.getPDFSettings();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TourComponent.prototype.saveV3Settings = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var tasks, _loop_2, this_2, _i, _a, element, result, suggestedIti1, suggestedIti2, suggestedIti3, data, tripPlannerSettings;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tasks = [];
                        _loop_2 = function (element) {
                            if (this_2[element + 'ImgData']) {
                                tasks.push(this_2.hubApiService
                                    .uploadBase64ImageToAWS(this_2[element + 'ImgData'])
                                    .then(function (url) { return (__assign({}, url, { type: element })); }));
                            }
                        };
                        this_2 = this;
                        for (_i = 0, _a = ['banner', 'event', 'place', 'itinerary', 'trip']; _i < _a.length; _i++) {
                            element = _a[_i];
                            _loop_2(element);
                        }
                        return [4 /*yield*/, Promise.all(tasks)];
                    case 1:
                        result = _b.sent();
                        console.log(result);
                        if (result.some(function (item) { return !item.success; })) {
                            this.alertify.error('Upload image failed, please try again.');
                            return [2 /*return*/];
                        }
                        suggestedIti1 = this.editTourForm.get('v3DefaultAISuggestedItinerary1').value;
                        suggestedIti2 = this.editTourForm.get('v3DefaultAISuggestedItinerary2').value;
                        suggestedIti3 = this.editTourForm.get('v3DefaultAISuggestedItinerary3').value;
                        data = [];
                        if (suggestedIti1) {
                            data.push({ title: suggestedIti1 });
                        }
                        if (suggestedIti2) {
                            data.push({ title: suggestedIti2 });
                        }
                        if (suggestedIti3) {
                            data.push({ title: suggestedIti3 });
                        }
                        tripPlannerSettings = {
                            mobileLandingPage: {
                                bannerImage: result.find(function (r) { return r.type === 'banner'; })
                                    ? result.find(function (r) { return r.type === 'banner'; }).url || this.tpSettings.mobileLandingPage.bannerImage
                                    : this.tpSettings.mobileLandingPage.bannerImage,
                                eventImage: result.find(function (r) { return r.type === 'event'; })
                                    ? result.find(function (r) { return r.type === 'event'; }).url || this.tpSettings.mobileLandingPage.eventImage
                                    : this.tpSettings.mobileLandingPage.eventImage,
                                placeImage: result.find(function (r) { return r.type === 'place'; })
                                    ? result.find(function (r) { return r.type === 'place'; }).url || this.tpSettings.mobileLandingPage.placeImage
                                    : this.tpSettings.mobileLandingPage.placeImage,
                                itineraryImage: result.find(function (r) { return r.type === 'itinerary'; })
                                    ? result.find(function (r) { return r.type === 'itinerary'; }).url || this.tpSettings.mobileLandingPage.itineraryImage
                                    : this.tpSettings.mobileLandingPage.itineraryImage,
                                tripImage: result.find(function (r) { return r.type === 'trip'; })
                                    ? result.find(function (r) { return r.type === 'trip'; }).url || this.tpSettings.mobileLandingPage.tripImage
                                    : this.tpSettings.mobileLandingPage.tripImage,
                                bannerText1: this.editTourForm.get('mobileBannerText1').value,
                                bannerText2: this.editTourForm.get('mobileBannerText2').value,
                            },
                            defaultAISuggestedItineraries: data,
                            desktopPage: this.tpSettings.desktopPage,
                        };
                        console.log(tripPlannerSettings);
                        this.customizationService
                            .setTripPlannerSettings(this.hubName, tripPlannerSettings)
                            .finally(event.complete)
                            .subscribe(function () {
                            _this.alertify.successfully('Update Trip Planner settings');
                            if (!window.location.href.includes('localhost')) {
                                var authToken = localStorage.getItem(localStorageKeys.authToken);
                                if (authToken) {
                                    var tokenInfo = jwt_decode(authToken);
                                    try {
                                        var trackName = 'TripPlanner - V3 - SaveSettings';
                                        window['pendo'].track(trackName, {
                                            accountId: tokenInfo.userName,
                                            timestamp: Date.now(),
                                            hubName: _this.hubName,
                                        });
                                    }
                                    catch (error) {
                                        console.error(error);
                                    }
                                }
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    TourComponent.prototype.getPDFSettings = function () {
        var _this = this;
        this.customizationService.getPDFSettings(this.hubName).subscribe(function (settings) {
            _this.tempPDFSettings.pdf.headerImage.event.isDefault =
                isNullOrUndefined(settings) ||
                    isNullOrUndefined(settings.pdf.headerImage.event.isDefault) ||
                    settings.pdf.headerImage.event.isDefault;
            _this.tempPDFSettings.pdf.headerImage.event.url = _this.tempPDFSettings.pdf.headerImage.event.isDefault
                ? null
                : settings.pdf.headerImage.event.url;
            _this.tempPDFSettings.pdf.headerImage.place.isDefault =
                isNullOrUndefined(settings) ||
                    isNullOrUndefined(settings.pdf.headerImage.place.isDefault) ||
                    settings.pdf.headerImage.place.isDefault;
            _this.tempPDFSettings.pdf.headerImage.place.url = _this.tempPDFSettings.pdf.headerImage.place.isDefault
                ? null
                : settings.pdf.headerImage.place.url;
            _this.tempPDFSettings.pdf.headerImage.tour.isDefault =
                isNullOrUndefined(settings) ||
                    isNullOrUndefined(settings.pdf.headerImage.tour.isDefault) ||
                    settings.pdf.headerImage.tour.isDefault;
            _this.tempPDFSettings.pdf.headerImage.tour.url = _this.tempPDFSettings.pdf.headerImage.tour.isDefault
                ? null
                : settings.pdf.headerImage.tour.url;
            _this.tempPDFSettings.pdf.headerImage.trip.isDefault =
                isNullOrUndefined(settings) ||
                    isNullOrUndefined(settings.pdf.headerImage.trip.isDefault) ||
                    settings.pdf.headerImage.trip.isDefault;
            _this.tempPDFSettings.pdf.headerImage.trip.url = _this.tempPDFSettings.pdf.headerImage.trip.isDefault
                ? null
                : settings.pdf.headerImage.trip.url;
            var data = new PDFSettingCommand();
            data.pdf.headerImage = {
                event: {
                    isDefault: _this.tempPDFSettings.pdf.headerImage.event.isDefault,
                    url: _this.tempPDFSettings.pdf.headerImage.event.url,
                },
                place: {
                    isDefault: _this.tempPDFSettings.pdf.headerImage.place.isDefault,
                    url: _this.tempPDFSettings.pdf.headerImage.place.url,
                },
                tour: {
                    isDefault: _this.tempPDFSettings.pdf.headerImage.tour.isDefault,
                    url: _this.tempPDFSettings.pdf.headerImage.tour.url,
                },
                trip: {
                    isDefault: _this.tempPDFSettings.pdf.headerImage.trip.isDefault,
                    url: _this.tempPDFSettings.pdf.headerImage.trip.url,
                },
            };
            _this.pdfSettingsStore.pdfCommand.next(data);
        });
    };
    TourComponent.prototype.showMobileEdit = function () {
        this.tourMobileDetail.nativeElement.style.top = '0px';
    };
    TourComponent.prototype.hideMobileEdit = function () {
        this.tourMobileDetail.nativeElement.style.top = '100%';
        this.isShowMobileEdit = false;
    };
    return TourComponent;
}(BaseComponent));
export { TourComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/tours/tours/tour.component.ts.pre-build-optimizer.js